export enum EnumGrupoPermissao {
    CADASTROS = "Cadastros",
    FARMACIAS = "Farmácias",
    FOOD = "Food",
    ADMINISTRATIVO = "Administrativo",
    OPERACOES_DE_VENDA = "Operação de Venda",    
}